// extracted by mini-css-extract-plugin
module.exports = {"Quote":"Quote_Quote__EdZCw","Quote___secondary":"Quote_Quote___secondary__EywBO"};